import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@homeleite/arch';
import { LoginResult, LoginValidator } from '@homeleite/common-pages';
import { LoginService } from './login.service';

@Component({
    selector: 'admin-login',
    template: ` <app-login [validator]="validator"></app-login>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoginComponent {
  constructor(
    public validator: LoginService,
    authService: AuthService,
    router: Router
  ) {
    if (authService.hasToken) {
      router.navigateByUrl('/');
    }
  }
}
